import { FII_CLEAR_MSG, FII_DII, FII_DII_ERROR, FII_DII_HIDE_ERROR, FII_DII_START_LOADER, FII_DII_STOP_LOADER, FII_MSG, } from "../../interface/iFiiDii";
const initialState = {
    data: {
        lastUpdatedTime: "",
        diiCash: [],
        fiiCash: [],
        fiiFuture: [],
        fiiOption: []
    },
    fiiCashMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    diiCashMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    fiiFutureMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    fiiOptionMessage: {
        msg: null,
        show: false,
        icon: null,
    },
    fiiDiiLoader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const fiiDii = (state = initialState, action) => {
    switch (action.type) {
        case FII_DII:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case FII_DII_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case FII_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: action.payload.message });
        case FII_CLEAR_MSG:
            return Object.assign(Object.assign({}, state), { [action.errorMsg]: initialState[action.errorMsg] });
        case FII_DII_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case FII_DII_START_LOADER:
            return Object.assign(Object.assign({}, state), { fiiDiiLoader: true });
        case FII_DII_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { fiiDiiLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default fiiDii;
